import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";

const CATS = ["All","Wedding Planning","Wedding Venues","Real Weddings","Photography Tips","Videography Tips","Destination Weddings"];

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("All");
  useEffect(() => { api.get("/blog").then(r => setPosts(r.data)).catch(()=>{}); }, []);
  const filtered = cat === "All" ? posts : posts.filter(p => p.category === cat);
  return (
    <div data-testid="blog-page" className="pt-32">
      <SEO title="Journal" path="/blog" description="Honest notes from behind the camera — wedding planning advice, real love stories, and the little details that make a day feel like yours." />
      <section className="section-pad pb-12 max-w-[1400px] mx-auto text-center">
        <div className="eyebrow">Journal</div>
        <h1 className="font-serif text-5xl md:text-6xl font-light mt-4 tracking-tight">The <em className="text-[#D4AF37] not-italic">Journal</em></h1>
      </section>
      <div className="flex flex-wrap justify-center gap-2 px-6">
        {CATS.map(c => (
          <button key={c} onClick={()=>setCat(c)} data-testid={`blog-cat-${c.toLowerCase().replace(/\s/g,'-')}`}
            className={`px-4 py-2 text-[0.7rem] tracking-[0.18em] uppercase border transition ${cat===c?"border-[#D4AF37] text-[#D4AF37]":"border-white/15 text-white/60 hover:border-white/40"}`}>{c}</button>
        ))}
      </div>
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {filtered.map(p => (
          <Link to={`/blog/${p.slug}`} key={p.id} className="group" data-testid={`blog-card-${p.slug}`}>
            <div className="aspect-[4/3] overflow-hidden hover-zoom">
              <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover" />
            </div>
            <div className="mt-5">
              <div className="text-[0.65rem] tracking-[0.3em] uppercase text-[#D4AF37]">{p.category}</div>
              <h3 className="font-serif text-2xl mt-2 group-hover:text-[#D4AF37] transition">{p.title}</h3>
              <p className="text-sm text-white/60 mt-3 leading-relaxed">{p.excerpt}</p>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
